import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Testimonial() {
  return <section id="case-studies" className="py-16 lg:py-24 px-4 md:px-6" data-id="element-323">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="w-[95%] mx-auto bg-primary-dark rounded-3xl overflow-hidden relative" data-id="element-324">
        <div className="grid lg:grid-cols-2 min-h-[500px]" data-id="element-325">
          {/* Left — Image */}
          <div className="relative h-72 lg:h-auto" data-id="element-326">
            <img src="https://cdn.magicpatterns.com/uploads/6woGoZZ58PZurSZ7Y9FmxV/subway-welcome.jpg" alt="Subway Kent — AccuTemp commercial HVAC installation" className="absolute inset-0 w-full h-full object-cover" data-id="element-327" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-primary-dark/30 hidden lg:block" data-id="element-328"></div>
          </div>

          {/* Right — Quote */}
          <div className="relative flex flex-col justify-center p-10 md:p-14 lg:p-16" data-id="element-329">
            {/* Large decorative quote mark */}
            <div className="text-[220px] md:text-[280px] leading-none font-serif text-accent/10 select-none absolute -top-16 -left-4 pointer-events-none" data-id="element-330">
              "
            </div>

            <div className="relative z-10" data-id="element-331">
              <span className="text-xs uppercase tracking-[0.2em] font-medium text-accent mb-8 block" data-id="element-332">
                What our clients say
              </span>

              <blockquote className="text-2xl md:text-3xl lg:text-4xl font-serif text-white leading-[1.5] mb-10 tracking-tight" data-id="element-333">
                "AccuTemp's in-house team resolved our cooling issues in days,
                not the weeks we'd been quoted elsewhere. Their service reports
                are the most thorough we've seen."
              </blockquote>

              <div className="flex items-center gap-5" data-id="element-334">
                <div className="w-12 h-[2px] bg-accent" data-id="element-335"></div>
                <div data-id="element-336">
                  <div className="text-white font-medium mb-0.5" data-id="element-337">
                    James Mitchell
                  </div>
                  <div className="text-white/50 text-sm" data-id="element-338">
                    Facilities Manager, Coventry Retail Park
                  </div>
                </div>
              </div>
            </div>

            {/* Top-right link */}
            <Link to="/case-studies" className="absolute top-8 right-8 md:top-10 md:right-10 hidden md:flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors" data-id="element-339">
              See more stories
              <ArrowRight className="w-4 h-4" data-id="element-340" />
            </Link>
          </div>
        </div>
      </motion.div>
    </section>;
}